module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j7eIR"))).then(() => parcelRequire('3a9aZ'));